import { useEffect, useMemo, useState } from 'react';
import { Menu } from 'antd';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useNavigateApi from '../../appRoute/useNavigateApi';

const AnalyticsMenu = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigateApi = useNavigateApi();

  const [selectedMenuKey, setSelectedMenuKey] = useState(location.pathname);

  const lang = useSelector((state) => {
    return state.lang;
  });

  useEffect(() => {
    if (location.pathname.startsWith(`/${lang}/analytics/manager`)) {
      setSelectedMenuKey(`/${lang}/analytics/manager`);
    } else {
      setSelectedMenuKey(location.pathname);
    }
  }, [lang, location.pathname]);

  const items = useMemo(() => {
    return [
      {
        key: `/${lang}/analytics/orders`,
        label: t('WORD_ORDERS'),
        onClick: () => {
          navigateApi(`/analytics/orders`);
        },
      },
      {
        key: `/${lang}/analytics/payments`,
        label: t('WORD_PAYMENTS'),
        onClick: () => {
          navigateApi(`/analytics/payments`);
        },
      },
      {
        key: `/${lang}/analytics/customers`,
        label: t('WORD_CUSTOMERS'),
        onClick: () => {
          navigateApi(`/analytics/customers`);
        },
      },
      {
        key: `/${lang}/analytics/manager`,
        label: t('WORD_MANAGERS'),
        onClick: () => {
          navigateApi(`/analytics/manager`);
        },
      },
    ];
  }, [lang, navigateApi, t]);

  return (
    <Menu
      className="second_side_menu"
      mode="vertical"
      defaultSelectedKeys={['1']}
      items={items}
      selectedKeys={[selectedMenuKey]}
      onSelect={(menu) => {
        setSelectedMenuKey(menu?.key);
      }}
    />
  );
};

export default AnalyticsMenu;
